const productHistory = []

export default {
  productHistory
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-search/store/state.js